import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';
import { MdSearch } from 'react-icons/lib/md';
import Select from 'react-select';

import { withAuth } from '../../actions/';
import { fetchProjects, setEmptyProjects, fetchProjectsAE } from '../../actions/projects_actions';
import { fetchAEprojectsInMyQueue, showSelectedProject } from '../../actions/additional_actions';
import { fetchSetup } from '../../actions/setup_actions';
import { fetchAdvanceSearchResults } from '../../actions/project_actions';
import Pagination from '../global/pagination';
import ProjectCard from './project_card';
import { Tabs, Tab } from '../global/tabs';
import AeBidTrackReport from '../detail/AeBidTrackReport';
import ContractorsSubTab from '../detail/ContractorsSubTab';
import ManageStudioSubTab from '../detail/ManageStudioSubTab';
import ProjectCardAE from './project_card_AE';
import AeSearch from './aeSearch';
import AdvanceSearch from './advanceSearch';
import FactSheetTab from '../detail/FactSheetTab';

const EMPTY_MESSAGES = {
    'watchlist': 'There are no projects in your watch list at the moment.',
    'search': 'There are no projects matching that query.',
    'reports': 'There are currently no reports associated with your profile.',
}

class ProjectList extends Component {
    
    constructor(props) {
        super(props);

        this.props.setEmptyProjects();
        this.props.fetchSetup()

        this.timerId = 0;
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchPagination = this.handleSearchPagination.bind(this);
        this.toggleHiddenSearch = this.toggleHiddenSearch.bind(this);

        this.state = {
            isHidden: true,
            projectId: '',
            projectIdAE: '',
            strategyBoardDateFrom: '',
            strategyBoardDateTo: '',
            countDown: '',
            query: '',
            benchmarkStatus: '',
            aeProjectIdInQueue: '',
            isSelectedAE: false,
        }
    }

    UNSAFE_componentWillMount() {
        const { filter, page, pageAEprojects, aeProjectsInMyQueue } = this.props;

        this.props.fetchProjects(filter, { skip: page * 10 })
        this.props.fetchProjectsAE(filter, { skip: pageAEprojects * 10 })

        if (aeProjectsInMyQueue && aeProjectsInMyQueue.length === 0) {
            this.props.fetchAEprojectsInMyQueue();
        } 
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { filter, page, pageAEprojects, aeProjectsInMyQueue } = this.props;

        if (filter !== nextProps.filter || page !== nextProps.page || pageAEprojects !== nextProps.pageAEprojects) {
            this.props.fetchProjects(nextProps.filter, { skip: nextProps.page * 10 })
            this.props.fetchProjectsAE(nextProps.filter, { skip: nextProps.pageAEprojects * 10 })

            if (aeProjectsInMyQueue && aeProjectsInMyQueue.length === 0) {
                this.props.fetchAEprojectsInMyQueue();
            } 
        }
    }

    handleSearch(e) {
        e.preventDefault();
        const { filter, currentPage } = this.props;
        const query = e.target.value;
        this.setState({ query: e.target.value });
        clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
            const params = { query: query, currentPage: 0, skip: currentPage * 10 };
            this.props.fetchProjects(filter, params);
        }, 300);
    }

    handleSearchPagination(currentPage) {
        return (e) => { 
            e.preventDefault();
            const { filter } = this.props;
            const { query } = this.state;
            clearTimeout(this.timerId);
            this.timerId = setTimeout(() => {
                const params = { query: query, currentPage, skip: currentPage * 10 };
                this.props.fetchProjects(filter, params);
            }, 300);
        }
    }

    toggleHiddenSearch(e) {
        e.preventDefault();
        this.setState({
            isHidden: !this.state.isHidden
        })
    }

    changeWatchFor({ projectId, inWatchlist }) {
        const method = inWatchlist ? 'delete' : 'post';
        return withAuth(
      { method, url: 'projects/watchlist', params: { projectId } },
      () => this.props.changeWatchFor(projectId, !inWatchlist)
    )
    }

    renderPagination() {
        const { page, filter, projects, count } = this.props;

        if (projects.length === 0) return null;
        return (
      <div className="container">
        <div className="row">
          <div className="col s12">
            <Pagination
              baseUrl={filter}
              pageCount={Math.floor(count / 10)}
              currentPage={page} />
          </div>
        </div>
      </div>
        )
    }

    renderPaginationAEprojects() {
        const { pageAEprojects, filter, projectsAE, projectsCountAEprojects } = this.props;

        if (projectsAE.length === 0) return null;
        return (
      <div className="container">
        <div className="row">
          <div className="col s12">
            <Pagination
              baseUrl={filter}
              pageCount={Math.floor(projectsCountAEprojects / 10)}
              currentPage={pageAEprojects} />
          </div>
        </div>
      </div>
        )
    }

    renderPaginationSearch() {
        const { currentPage, projects, count } = this.props;
        const rem = count % 10;
        const divCount = Math.floor(count / 10);
        const pageCount = (rem === 0) ? divCount - 1 : divCount;

        if (projects.length === 0) return null;
        return (
      <div className="container">
        <div className="row">
          <div className="col s12">

            <ul className="pagination">
              <li className="prev">{currentPage > 0 ? <a href="# " onClick={this.handleSearchPagination(currentPage - 1)}>← Previous</a> : null}</li>
              <li className="next">{currentPage < pageCount ? <a href="# " onClick={this.handleSearchPagination(currentPage + 1)}>Next →</a> : null}</li>
            </ul>

          </div>
        </div>
      </div>
        )
    }

    renderLoading() {
        if (!this.props.projectsLoading) return null;
        return <div className="loader" />
    }

    renderEmpty() {
        if (!this.props.projectsEmpty) {
            return null;
        }

        return (
      <div className="container projects-empty">
        <div className="row">
          <div className="col s12">
            <p>{EMPTY_MESSAGES[this.props.filter]}</p>
          </div>
        </div>
      </div>
        )
    }

    handleSelectChangeAEbyQueue(aeProjectIdInQueue) {
        return (option) => {
            const value = option ? option.value : null;
            this.setState({ aeProjectIdInQueue: value });

            if (value !== null && value !== '' && value !== undefined) {
                this.props.showSelectedProject(value);
                this.setState({ isSelectedAE: true });
            }
            else
        this.setState({ isSelectedAE: false });
        }
    }

    getAEprojectsByQueue() {
        const { aeProjectsInMyQueue } = this.props;
        return aeProjectsInMyQueue && aeProjectsInMyQueue.map(option => {
            return {
                label: option,
                value: option
            }
        });
    }

    render() {
        const { filter, projects, pmReqAEServProjId, projectsAE, } = this.props;
        const { redirect, projectIdAEGrid, aeProjectIdInQueue } = this.state;

        if (redirect) {
            const path = `/projects/${projectIdAEGrid}`;
            return <Redirect push={true} to={path} />;
        }

        const cards = projects.map(project =>
      <div key={project.projectId} className="container">
        <div className="row">
          <div className="col s12">
            <ProjectCard
              project={project}
              onChangeWatch={() => this.changeWatchFor(project)}
              pmReqAEServProjId={pmReqAEServProjId}
            />
          </div>
        </div>
      </div>
    );

        const cardsAE =
      <div>

        <div className="container">
          <div className='row'>
            <div className='col s6 m4 l2 margin-bottom-075 margin-top-075'>
              <div className="controls with-select">
                <label className="label-select-search">Projects in my queue</label>
                <Select name=''
                  value={aeProjectIdInQueue}
                  options={this.getAEprojectsByQueue()}
                  onChange={this.handleSelectChangeAEbyQueue(aeProjectIdInQueue)}
                />
              </div>
            </div>
          </div>
        </div>

        {this.state.isSelectedAE
          ? this.props.selectedProject_AE.map(project =>
            <div key={project.projectId} className="container">
              <div className="row">
                <div className="col s12" ref={'col' + project.projectId}>
                  <ProjectCardAE
                    project={project}
                    onChangeWatch={() => this.changeWatchFor(project)}
                    pmReqAEServProjId={pmReqAEServProjId}
                  />
                </div>
              </div>
            </div>)

          : projectsAE.map(project =>
            <div key={project.projectId} className="container">
              <div className="row">
                <div className="col s12">
                  <ProjectCardAE
                    project={project}
                    onChangeWatch={() => this.changeWatchFor(project)}
                    pmReqAEServProjId={pmReqAEServProjId}
                  />
                </div>
              </div>
            </div>)}

      </div>

        return (
      <div className="project-list">
        {filter === 'search' ?
          <div>
            <div className="container">
              {this.state.isHidden
                ? <div className="row">
                  <div className="col s12">
                    <div className="search-box">
                      <input type="text" autoFocus
                        className="search-input"
                        placeholder="Please enter a Project ID, FMS ID, or Project Title ..."
                        onChange={this.handleSearch} />
                      <span> <MdSearch size={22} color='#8492a6' /></span>
                    </div>
                  </div>
                </div>
                : null}
            </div>

            {filter === 'search' &&
              <div className="container">
                <div className="row">
                  <div className="col s12">
                    <button type="button" onClick={this.toggleHiddenSearch}>
                      <h4 className="advance-search">Advanced search</h4>
                    </button>
                  </div>
                </div>
              </div>
            }

            {!this.state.isHidden && filter !== 'aeSearch' &&
              <AdvanceSearch isHidden={this.state.isHidden} />
            }
          </div>
          : null}

        {filter === 'reports' ?
          <div className="container bg-white">
            <Tabs className="subtabs-custom">
              <Tab iconClassName={'icon-class-1'}
                linkClassName={'custom-link'}
                tabIndex={0}
                tabName={'Contracts'}
                className="subtab-custom">
                <ContractorsSubTab />
              </Tab>
              <Tab iconClassName={'icon-class-1'}
                linkClassName={'custom-link'}
                tabIndex={0}
                tabName={'A&E Bid Package Tracking Report'}
                className="subtab-custom">
                <AeBidTrackReport />
              </Tab>
            </Tabs>
          </div>
          : null}

        {filter === 'aeSearch' &&
          <div>
            <AeSearch />
          </div>
        }

        {filter === 'studioMgmt' ?
          <div className="container bg-white margin-top-9">
            <ManageStudioSubTab />
          </div>
          : null}
          
          {filter === 'factsheet' ? 
            <div className="container bg-white margin-top-9">
              <FactSheetTab />
            </div>
            : null
          }

        <CSSTransitionGroup
          transitionName="card-effect"
          transitionEnterTimeout={400}
          transitionLeave={false}
        >

          {(filter === 'search' && this.state.isHidden) || filter === 'my-projects' || filter === 'watchlist'
            ? cards
            : filter === 'aeProjects'
              ? cardsAE
              : null}

        </CSSTransitionGroup>
        {this.renderEmpty()}
        {this.renderLoading()}
        {(filter === 'search' && this.state.isHidden) ? this.renderPaginationSearch() : null}
        {(filter === 'my-projects' || filter === 'watchlist') ? this.renderPagination() : null}
        {filter === 'aeProjects' ? this.renderPaginationAEprojects() : null}
      </div>
        );
    } // render()
}

ProjectList.propTypes = {
    filter: PropTypes.string.isRequired,
    page: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    projects: PropTypes.array.isRequired,
    projectsEmpty: PropTypes.bool.isRequired,
    projectsLoading: PropTypes.bool.isRequired,
    projectsAE: PropTypes.array.isRequired,
    fetchProjects: PropTypes.func.isRequired,
    fetchAdvanceSearchResults: PropTypes.func.isRequired,
    changeWatchFor: PropTypes.func.isRequired,
    setEmptyProjects: PropTypes.func.isRequired,
    fetchSetup: PropTypes.func.isRequired,
    fetchProjectsAE: PropTypes.func.isRequired,
    pageAEprojects: PropTypes.number.isRequired
};

function changeWatchFor(projectId, inWatchlist) {
    return dispatch => {
        dispatch({
            type: 'SET_WATCH_VALUE',
            payload: { projectId, inWatchlist }
        })
    }
}

function mapStateToProps(state, ownProps) {
    return {
        filter: ownProps.params.filter,
        page: parseInt(ownProps.params.page || '0', 10),
        pageAEprojects: parseInt(ownProps.params.page || '0', 10),
        currentPage: state.projectsStore.currentPage,
        count: state.projectsStore.projectsCount,
        projects: state.projectsStore.projects,
        projectsEmpty: state.projectsStore.projectsEmpty,
        projectsLoading: state.projectsStore.projectsLoading,
        setup: state.projectsStore.setup,
        benchmarkStatuses: state.projectsStore.benchmarkStatuses,
        pmReqAEServProjId: state.additionalProjectsStore.pmReqAEServProjId,

        aeProjectsInMyQueue: state.additionalProjectsStore.aeProjectsInMyQueue,
        selectedProject_AE: state.additionalProjectsStore.selectedProject_AE,

        currentPageAEprojects: state.projectsStore.currentPageAEprojects,
        projectsAE: state.projectsStore.projectsAE,
        projectsCountAEprojects: state.projectsStore.projectsCountAEprojects,
    }
}

export default connect(mapStateToProps, {
    fetchProjects,
    fetchAdvanceSearchResults,
    setEmptyProjects,
    changeWatchFor,
    fetchSetup,
    fetchProjectsAE,
    showSelectedProject,
    fetchAEprojectsInMyQueue,
})(ProjectList);